<template>
    <v-dialog v-model="localDialog" width="35%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0" :close-delay="0">
        <v-card>

            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? 'Add Hrm Letter Setup' : 'Update Hrm Letter Setup' }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="hrmLetterSetup">
                    <v-row>
                        <v-col cols="12"> 

                            <v-text-field
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="name.value.value"
                                :error-messages="name.errorMessage.value"
                                clearable
                            >
                                <template #label>
                                    Name <span class="text-red-accent-4">*</span>
                                </template>
                            </v-text-field>
                        
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>

                        <v-layout class="justify-end">
                            <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                            <v-btn 
                            class="bg-brand w-15 ms-2"
                            variant="flat" 
                            type="submit"
                            >
                                {{ isEntryMode ? 'Save' : 'Update' }}
                            </v-btn>
                        </v-layout>

                    </v-card-actions>
                </v-form>
            </v-card-text>
        
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
    name: 'hrmLetterSetup',
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({
                name: '',
                id: null,
            })
        }
    },
    data() {
        return {
            localDialog: this.dialog,
            errorMessages: '',
            loading: false,
            isEntryMode: true,
        }
    },
    computed: { },
    watch: {
        dialog(val) {
            this.localDialog = val
        },
        localDialog(val) {
            this.$emit('update:dialog', val)
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.name.setValue(newData.name || '', false);
                this.id.setValue(newData.id || '', false);
            },
        }
        
    },
    created() { },
    methods: {
        updateDialog(val) {
            this.$emit('update:dialog', val)
        },
        closeDialog() {
            this.$emit('update:dialog', false);
        },
    },
    setup(props, { emit }){
        const { handleSubmit, resetForm} = useForm({
            validationSchema: yup.object({
                name: yup.string().min(1).max(50).required().trim().label('Name'),
            }),
        });

        const name = useField('name');
        const status = useField('status');
        const id = useField('id');
        const errorMessages = ref('');
        const loading  = ref('');
        const store = useStore();

        const submit = handleSubmit((values) => {

            store.dispatch("saveUpdateHrmLetter", values)
                .then((response) => {
                    resetForm();
                    emit('update:dialog', false);
                    toast.success(response.data.message);
                    loading.value = true;

                    store.dispatch("getHrmLetterInfo")
                        .then(data => {
                            loading.value = false;
                        })
                        .catch(error => {
                            loading.value = false;
                            toast.error(error.response.data.message);
                        })
                })
                .catch((error) => {            
                    toast.error(error.response.data.message);          
                })
        });
        return {
            submit,
            name,
            status,
            errorMessages,
            id,
            resetForm,
            loading
        }
    },
    mounted() {
    }
}
</script>

